export enum Persons {
  Accounts = 'persons.accounts',
  Devices = 'persons.devices',
}
